import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ScheduleIcon from '@material-ui/icons/Schedule';
import BuildIcon from '@material-ui/icons/Build';
import Reveal from './Reveal';
import { colors } from '../theme';

const items = [
  { icon: CheckCircleIcon, title: 'Free estimates', text: 'No-cost, no-pressure quotes.' },
  { icon: ThumbUpIcon, title: 'Affordable prices', text: 'Quality work that fits your budget.' },
  { icon: ScheduleIcon, title: 'Available any time', text: 'Call or text whenever it suits you.' },
  { icon: BuildIcon, title: 'One call does it all', text: 'From lawn care to pressure washing.' },
];

const useStyles = makeStyles((theme) => ({
  strip: {
    position: 'relative',
    marginTop: -56,
    zIndex: 1,
    [theme.breakpoints.down('xs')]: {
      marginTop: -40,
    },
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    boxShadow: '0 12px 40px rgba(14,35,64,0.12)',
    padding: theme.spacing(3, 2),
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
  },
  icon: {
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(31,122,90,0.10)',
    color: colors.green,
  },
  title: {
    fontWeight: 700,
    fontFamily: theme.typography.h6.fontFamily,
    color: colors.navy,
    lineHeight: 1.3,
  },
  text: {
    color: theme.palette.text.secondary,
    fontSize: 14,
    lineHeight: 1.5,
  },
}));

export default function TrustStrip() {
  const classes = useStyles();

  return (
    <div className={classes.strip}>
      <Container maxWidth="lg">
        <Reveal>
          <Grid container className={classes.card}>
            {items.map(({ icon: Icon, title, text }) => (
              <Grid item xs={12} sm={6} md={3} key={title} className={classes.item}>
                <span className={classes.icon}>
                  <Icon />
                </span>
                <div>
                  <Typography className={classes.title}>{title}</Typography>
                  <Typography className={classes.text}>{text}</Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </Reveal>
      </Container>
    </div>
  );
}
